// Blog/Education Articles Data

export const blogCategories = [
  { id: "all", name: "Semua Artikel", count: 24 },
  { id: "branding", name: "Branding", count: 8 },
  { id: "social-media", name: "Social Media", count: 6 },
  { id: "ads", name: "Digital Ads", count: 5 },
  { id: "website", name: "Website", count: 3 },
  { id: "tips-umkm", name: "Tips UMKM", count: 7 },
];

export const blogArticles = [
  {
    id: 1,
    slug: "strategi-branding-umkm-2024",
    title: "7 Strategi Branding Terbaik untuk UMKM di Era Digital 2024",
    excerpt:
      "Pelajari strategi branding yang efektif untuk UMKM agar bisa bersaing di era digital. Mulai dari pemilihan warna, logo, hingga brand voice yang konsisten.",
    content: `
      <p>Di era digital saat ini, branding bukan lagi monopoli perusahaan besar. UMKM pun perlu memiliki identitas brand yang kuat untuk bisa bersaing dan bertahan di pasar yang semakin kompetitif.</p>
      
      <h2>Mengapa Branding Penting untuk UMKM?</h2>
      <p>Branding yang kuat membantu UMKM untuk:</p>
      <ul>
        <li>Membedakan diri dari kompetitor</li>
        <li>Membangun kepercayaan pelanggan</li>
        <li>Meningkatkan nilai perceived produk/jasa</li>
        <li>Menciptakan customer loyalty</li>
      </ul>
      
      <h2>7 Strategi Branding Efektif untuk UMKM</h2>
      
      <h3>1. Tentukan Brand Positioning yang Jelas</h3>
      <p>Brand positioning adalah bagaimana Anda ingin brand Anda diingat dan dipersepsikan oleh target market. Untuk UMKM, positioning harus:</p>
      <ul>
        <li>Sederhana dan mudah diingat</li>
        <li>Relevan dengan target market</li>
        <li>Berbeda dari kompetitor</li>
      </ul>
      
      <h3>2. Kembangkan Visual Identity yang Konsisten</h3>
      <p>Visual identity meliputi logo, warna, typography, dan elemen visual lainnya. Pastikan:</p>
      <ul>
        <li>Logo mudah diingat dan scalable</li>
        <li>Pallet warna yang tepat untuk industri Anda</li>
        <li>Typography yang readable dan sesuai brand personality</li>
      </ul>
      
      <h3>3. Bangun Brand Voice yang Autentik</h3>
      <p>Brand voice adalah cara brand Anda "berbicara" dengan audience. Untuk UMKM lokal, brand voice yang autentik dan personal sering kali lebih efektif.</p>
      
      <h3>4. Manfaatkan Storytelling</h3>
      <p>Ceritakan story di balik brand Anda. UMKM memiliki keunggulan dalam hal personal story dan connection dengan komunitas lokal.</p>
      
      <h3>5. Konsistensi di Semua Touchpoint</h3>
      <p>Pastikan brand experience yang konsisten di semua touchpoint - dari packaging, social media, hingga customer service.</p>
      
      <h3>6. Leverage Digital Platforms</h3>
      <p>Gunakan platform digital seperti Instagram, Facebook, dan website untuk membangun brand awareness dengan budget terbatas.</p>
      
      <h3>7. Monitor dan Evaluasi</h3>
      <p>Lakukan monitoring secara berkala untuk memastikan strategi branding Anda efektif dan sesuai dengan target.</p>
      
      <h2>Kesimpulan</h2>
      <p>Branding yang efektif adalah investasi jangka panjang untuk UMKM. Dengan strategi yang tepat dan eksekusi yang konsisten, UMKM dapat membangun brand yang kuat dan bersaing dengan player yang lebih besar.</p>
    `,
    author: "Tim Dreams Marketing",
    publishDate: "2024-01-15",
    readTime: "8 min",
    category: "branding",
    tags: ["branding", "umkm", "digital marketing", "strategi"],
    featuredImage:
      "https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    isPopular: true,
    views: 2450,
  },

  {
    id: 2,
    slug: "instagram-marketing-umkm",
    title: "Panduan Lengkap Instagram Marketing untuk UMKM Pemula",
    excerpt:
      "Tutorial step-by-step menggunakan Instagram untuk marketing UMKM. Mulai dari setup profil bisnis, content strategy, hingga Instagram Ads.",
    content: `
      <p>Instagram telah menjadi platform marketing yang sangat efektif untuk UMKM. Dengan lebih dari 1 miliar pengguna aktif, Instagram menawarkan peluang besar untuk menjangkau target audience.</p>
      
      <h2>Mengapa Instagram Penting untuk UMKM?</h2>
      <ul>
        <li>Visual-centric - cocok untuk showcase produk</li>
        <li>Engagement rate tinggi</li>
        <li>Biaya marketing yang relatif terjangkau</li>
        <li>Fitur business tools yang lengkap</li>
      </ul>
      
      <h2>Setup Profil Instagram Business yang Optimal</h2>
      
      <h3>1. Konversi ke Akun Bisnis</h3>
      <p>Langkah pertama adalah mengonversi akun personal menjadi business account untuk mendapatkan akses ke analytics dan advertising features.</p>
      
      <h3>2. Optimisasi Bio</h3>
      <p>Bio yang efektif harus mencakup:</p>
      <ul>
        <li>Nama bisnis yang jelas</li>
        <li>Value proposition singkat</li>
        <li>Call-to-action</li>
        <li>Contact information</li>
        <li>Link ke website/WhatsApp</li>
      </ul>
      
      <h3>3. Gunakan Profile Picture yang Profesional</h3>
      <p>Gunakan logo bisnis atau foto produk signature sebagai profile picture.</p>
      
      <h2>Content Strategy untuk Instagram</h2>
      
      <h3>Jenis Content yang Efektif:</h3>
      <ul>
        <li><strong>Product Showcase:</strong> Foto/video produk dengan lighting yang baik</li>
        <li><strong>Behind-the-Scenes:</strong> Proses pembuatan, daily operations</li>
        <li><strong>User-Generated Content:</strong> Customer testimonials, reviews</li>
        <li><strong>Educational Content:</strong> Tips, tutorial, how-to</li>
        <li><strong>Lifestyle Content:</strong> Content yang menunjukkan lifestyle brand</li>
      </ul>
      
      <h3>Posting Schedule yang Optimal</h3>
      <p>Berdasarkan research, waktu terbaik untuk posting adalah:</p>
      <ul>
        <li>Senin-Jumat: 11:00-13:00 dan 17:00-19:00</li>
        <li>Weekend: 10:00-11:00 dan 14:00-16:00</li>
      </ul>
      
      <h2>Instagram Features untuk Bisnis</h2>
      
      <h3>1. Instagram Stories</h3>
      <p>Gunakan Stories untuk content yang lebih casual dan real-time. Fitur polls, questions, dan stickers meningkatkan engagement.</p>
      
      <h3>2. Instagram Reels</h3>
      <p>Video pendek (15-30 detik) yang sangat efektif untuk viral marketing dan reach yang lebih luas.</p>
      
      <h3>3. Instagram Shop</h3>
      <p>Fitur e-commerce terintegrasi yang memungkinkan pelanggan berbelanja langsung dari Instagram.</p>
      
      <h3>4. IGTV</h3>
      <p>Untuk content video yang lebih panjang seperti tutorial atau behind-the-scenes yang detail.</p>
      
      <h2>Instagram Ads untuk UMKM</h2>
      
      <h3>Jenis Iklan yang Efektif:</h3>
      <ul>
        <li><strong>Photo Ads:</strong> Untuk product showcase</li>
        <li><strong>Video Ads:</strong> Untuk storytelling dan demonstrasi</li>
        <li><strong>Carousel Ads:</strong> Untuk menampilkan multiple products</li>
        <li><strong>Stories Ads:</strong> Untuk reach yang lebih natural</li>
      </ul>
      
      <h3>Targeting yang Tepat</h3>
      <p>Gunakan targeting berdasarkan:</p>
      <ul>
        <li>Lokasi (untuk bisnis lokal)</li>
        <li>Demografi (usia, gender, income)</li>
        <li>Interest dan behavior</li>
        <li>Custom audience (existing customers)</li>
      </ul>
      
      <h2>Measuring Success</h2>
      
      <h3>Key Metrics untuk UMKM:</h3>
      <ul>
        <li>Follower growth rate</li>
        <li>Engagement rate</li>
        <li>Reach dan impressions</li>
        <li>Website clicks</li>
        <li>Conversion rate</li>
      </ul>
      
      <h2>Tips Praktis</h2>
      
      <ol>
        <li><strong>Gunakan Hashtag yang Relevan:</strong> Mix antara popular, niche, dan branded hashtags</li>
        <li><strong>Engage dengan Audience:</strong> Respond to comments dan DMs dengan cepat</li>
        <li><strong>Collaborate:</strong> Partner dengan micro-influencers atau businesses lain</li>
        <li><strong>Consistency is Key:</strong> Posting secara konsisten lebih penting daripada posting frequently</li>
        <li><strong>Quality over Quantity:</strong> Lebih baik posting 3x seminggu dengan kualitas tinggi</li>
      </ol>
      
      <h2>Kesimpulan</h2>
      <p>Instagram marketing untuk UMKM membutuhkan strategi yang tepat dan eksekusi yang konsisten. Fokus pada quality content, engagement dengan audience, dan penggunaan fitur-fitur Instagram secara optimal.</p>
    `,
    author: "Sarah Wijaya",
    publishDate: "2024-01-12",
    readTime: "12 min",
    category: "social-media",
    tags: ["instagram", "social media", "umkm", "content marketing"],
    featuredImage:
      "https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    isPopular: true,
    views: 3200,
  },

  {
    id: 3,
    slug: "google-ads-umkm-budget-terbatas",
    title: "Cara Efektif Menjalankan Google Ads dengan Budget Terbatas",
    excerpt:
      "Strategi Google Ads yang tepat sasaran untuk UMKM dengan budget marketing terbatas. Tips optimasi dan targeting untuk ROI maksimal.",
    content: `
      <p>Google Ads adalah salah satu platform advertising yang paling efektif untuk UMKM, namun banyak yang takut mencoba karena khawatir budget habis tanpa hasil yang signifikan.</p>
      
      <h2>Mengapa Google Ads Cocok untuk UMKM?</h2>
      <ul>
        <li>Targeting yang sangat spesifik</li>
        <li>Budget control yang fleksibel</li>
        <li>Results yang measurable</li>
        <li>Quick results dibanding SEO</li>
      </ul>
      
      <h2>Persiapan Sebelum Memulai Google Ads</h2>
      
      <h3>1. Tentukan Tujuan yang Jelas</h3>
      <p>Apakah Anda ingin:</p>
      <ul>
        <li>Meningkatkan website traffic</li>
        <li>Generate leads</li>
        <li>Increase online sales</li>
        <li>Brand awareness</li>
      </ul>
      
      <h3>2. Riset Keyword yang Tepat</h3>
      <p>Gunakan tools seperti Google Keyword Planner untuk menemukan keywords dengan:</p>
      <ul>
        <li>Search volume yang cukup</li>
        <li>Competition yang tidak terlalu tinggi</li>
        <li>Relevan dengan bisnis Anda</li>
      </ul>
      
      <h3>3. Setup Conversion Tracking</h3>
      <p>Pastikan Anda bisa track conversions untuk mengukur ROI campaign.</p>
      
      <h2>Strategi Budget untuk UMKM</h2>
      
      <h3>1. Mulai dengan Budget Kecil</h3>
      <p>Untuk pemula, mulai dengan budget Rp 300,000 - Rp 500,000 per bulan untuk testing.</p>
      
      <h3>2. Focus pada High-Intent Keywords</h3>
      <p>Pilih keywords yang menunjukkan buying intent seperti:</p>
      <ul>
        <li>"beli [produk] [lokasi]"</li>
        <li>"jasa [service] terdekat"</li>
        <li>"harga [produk]"</li>
      </ul>
      
      <h3>3. Gunakan Negative Keywords</h3>
      <p>Tambahkan negative keywords untuk menghindari clicks yang tidak relevan.</p>
      
      <h2>Jenis Campaign yang Efektif untuk UMKM</h2>
      
      <h3>1. Search Campaigns</h3>
      <p>Paling efektif untuk UMKM karena target audience sedang aktif mencari produk/jasa Anda.</p>
      
      <h3>2. Local Campaigns</h3>
      <p>Ideal untuk bisnis dengan lokasi fisik, seperti restoran, toko, atau jasa lokal.</p>
      
      <h3>3. Shopping Campaigns</h3>
      <p>Cocok untuk e-commerce, menampilkan produk langsung di search results.</p>
      
      <h2>Optimasi untuk Budget Terbatas</h2>
      
      <h3>1. Geographic Targeting</h3>
      <p>Batasi targeting ke area yang paling relevan dengan bisnis Anda.</p>
      
      <h3>2. Time-based Targeting</h3>
      <p>Jalankan ads hanya pada jam-jam ketika target audience paling aktif.</p>
      
      <h3>3. Device Targeting</h3>
      <p>Analyze performance per device dan adjust bid accordingly.</p>
      
      <h3>4. Ad Extensions</h3>
      <p>Gunakan semua relevant ad extensions untuk meningkatkan ad visibility tanpa biaya tambahan:</p>
      <ul>
        <li>Sitelink extensions</li>
        <li>Call extensions</li>
        <li>Location extensions</li>
        <li>Callout extensions</li>
      </ul>
      
      <h2>Landing Page yang Efektif</h2>
      
      <h3>Elemen Penting Landing Page:</h3>
      <ul>
        <li><strong>Relevant headline:</strong> Sesuai dengan ad copy</li>
        <li><strong>Clear value proposition</strong></li>
        <li><strong>Simple form:</strong> Jangan minta terlalu banyak informasi</li>
        <li><strong>Mobile-friendly</strong></li>
        <li><strong>Fast loading speed</strong></li>
        <li><strong>Clear call-to-action</strong></li>
      </ul>
      
      <h2>Monitoring dan Optimisasi</h2>
      
      <h3>Key Metrics untuk UMKM:</h3>
      <ul>
        <li><strong>CTR (Click-Through Rate):</strong> Target min 2%</li>
        <li><strong>Quality Score:</strong> Target 7+</li>
        <li><strong>Conversion Rate:</strong> Varies by industry</li>
        <li><strong>Cost per Conversion</strong></li>
        <li><strong>ROAS (Return on Ad Spend)</strong></li>
      </ul>
      
      <h3>Optimisasi Berkelanjutan:</h3>
      <ol>
        <li>Review performance weekly</li>
        <li>Pause underperforming keywords</li>
        <li>Increase bids untuk high-performing keywords</li>
        <li>Test different ad copies</li>
        <li>Expand successful campaigns</li>
      </ol>
      
      <h2>Common Mistakes yang Harus Dihindari</h2>
      
      <ul>
        <li><strong>Targeting terlalu luas:</strong> Waste budget untuk audience yang tidak relevan</li>
        <li><strong>Tidak menggunakan negative keywords</strong></li>
        <li><strong>Landing page yang tidak relevan</strong></li>
        <li><strong>Tidak tracking conversions</strong></li>
        <li><strong>Set and forget mentality</strong></li>
      </ul>
      
      <h2>Kesimpulan</h2>
      <p>Google Ads bisa sangat efektif untuk UMKM jika dijalankan dengan strategi yang tepat. Kunci sukses adalah starting small, focus pada targeting yang tepat, dan optimisasi berkelanjutan berdasarkan data performance.</p>
    `,
    author: "Dimas Prakoso",
    publishDate: "2024-01-10",
    readTime: "10 min",
    category: "ads",
    tags: ["google ads", "ppc", "umkm", "budget terbatas"],
    featuredImage:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    isPopular: true,
    views: 2850,
  },

  {
    id: 4,
    slug: "website-umkm-konversi-tinggi",
    title: "Panduan Membuat Website UMKM yang Convert Tinggi",
    excerpt:
      "Tips dan trik membuat website untuk UMKM yang tidak hanya terlihat bagus, tapi juga efektif mengkonversi visitor menjadi customer.",
    content: `
      <p>Website adalah aset digital paling penting untuk UMKM di era digital. Namun, banyak website UMKM yang hanya berfungsi sebagai 'brosur digital' tanpa memaksimalkan potensi konversi.</p>
      
      <h2>Mengapa Website Penting untuk UMKM?</h2>
      <ul>
        <li>Credibility dan profesionalisme</li>
        <li>24/7 sales channel</li>
        <li>Cost-effective marketing tool</li>
        <li>Data dan analytics</li>
        <li>Scalability</li>
      </ul>
      
      <h2>Elemen Website yang Must-Have untuk UMKM</h2>
      
      <h3>1. Homepage yang Compelling</h3>
      
      <h4>Hero Section:</h4>
      <ul>
        <li><strong>Clear value proposition:</strong> Dalam 5-10 kata</li>
        <li><strong>Supporting headline:</strong> Penjelasan lebih detail</li>
        <li><strong>Hero image/video:</strong> Visual yang mendukung message</li>
        <li><strong>Primary CTA:</strong> Action yang paling diinginkan</li>
      </ul>
      
      <h4>Social Proof:</h4>
      <ul>
        <li>Customer testimonials</li>
        <li>Logos klien/partner</li>
        <li>Review ratings</li>
        <li>Case studies singkat</li>
      </ul>
      
      <h3>2. Halaman Produk/Jasa yang Detail</h3>
      
      <p>Setiap halaman produk/jasa harus memiliki:</p>
      <ul>
        <li><strong>High-quality images:</strong> Multiple angles, zoom functionality</li>
        <li><strong>Detailed descriptions:</strong> Features, benefits, specifications</li>
        <li><strong>Pricing yang jelas</strong></li>
        <li><strong>CTA yang prominent</strong></li>
        <li><strong>Customer reviews</strong></li>
      </ul>
      
      <h3>3. About Page yang Membangun Trust</h3>
      
      <p>About page sering kali adalah halaman kedua yang paling banyak dikunjungi. Include:</p>
      <ul>
        <li>Story founder/company</li>
        <li>Mission dan values</li>
        <li>Team photos</li>
        <li>Achievements/credentials</li>
        <li>Why customers should choose you</li>
      </ul>
      
      <h3>4. Contact & Location Information</h3>
      
      <ul>
        <li>Multiple contact methods</li>
        <li>Business hours</li>
        <li>Physical address (jika ada)</li>
        <li>Google Maps integration</li>
        <li>Contact form yang simple</li>
      </ul>
      
      <h2>UX/UI Design untuk Konversi</h2>
      
      <h3>1. Mobile-First Design</h3>
      <p>Lebih dari 60% traffic website berasal dari mobile. Pastikan:</p>
      <ul>
        <li>Responsive design di semua devices</li>
        <li>Touch-friendly buttons (min 44px)</li>
        <li>Fast loading speed</li>
        <li>Easy navigation</li>
      </ul>
      
      <h3>2. Navigation yang Intuitif</h3>
      
      <p>Struktur navigation yang efektif:</p>
      <ul>
        <li>Maximum 7 items di main menu</li>
        <li>Descriptive menu labels</li>
        <li>Breadcrumb navigation</li>
        <li>Search functionality</li>
      </ul>
      
      <h3>3. Loading Speed Optimization</h3>
      
      <p>Target loading speed < 3 detik dengan:</p>
      <ul>
        <li>Image optimization</li>
        <li>Caching</li>
        <li>CDN usage</li>
        <li>Minimize plugins</li>
      </ul>
      
      <h2>Conversion Rate Optimization (CRO)</h2>
      
      <h3>1. Call-to-Action (CTA) yang Efektif</h3>
      
      <h4>Best Practices untuk CTA:</h4>
      <ul>
        <li><strong>Action-oriented text:</strong> "Pesan Sekarang", "Dapatkan Penawaran"</li>
        <li><strong>Contrasting colors:</strong> Menonjol dari background</li>
        <li><strong>Strategic placement:</strong> Above the fold dan di akhir content</li>
        <li><strong>Urgency/scarcity:</strong> "Terbatas", "Hari ini saja"</li>
      </ul>
      
      <h3>2. Forms Optimization</h3>
      
      <p>Untuk lead generation forms:</p>
      <ul>
        <li>Minimize form fields</li>
        <li>Use smart defaults</li>
        <li>Clear error messages</li>
        <li>Progress indicators untuk multi-step forms</li>
      </ul>
      
      <h3>3. Trust Signals</h3>
      
      <p>Elemen yang membangun kepercayaan:</p>
      <ul>
        <li>Security badges (SSL certificate)</li>
        <li>Payment method icons</li>
        <li>Customer testimonials</li>
        <li>Business certifications</li>
        <li>Return/refund policy</li>
      </ul>
      
      <h2>SEO untuk UMKM</h2>
      
      <h3>On-Page SEO Basics:</h3>
      
      <ul>
        <li><strong>Title tags:</strong> Include target keywords</li>
        <li><strong>Meta descriptions:</strong> Compelling dan include CTA</li>
        <li><strong>Header structure:</strong> H1, H2, H3 hierarchy</li>
        <li><strong>Image alt text:</strong> Descriptive untuk accessibility</li>
        <li><strong>Internal linking:</strong> Connect related pages</li>
      </ul>
      
      <h3>Local SEO untuk UMKM:</h3>
      
      <ul>
        <li>Google My Business optimization</li>
        <li>Local keywords targeting</li>
        <li>NAP consistency (Name, Address, Phone)</li>
        <li>Local business schema markup</li>
      </ul>
      
      <h2>Analytics dan Tracking</h2>
      
      <h3>Essential Tools:</h3>
      
      <ul>
        <li><strong>Google Analytics:</strong> Website traffic dan behavior</li>
        <li><strong>Google Search Console:</strong> SEO performance</li>
        <li><strong>Hotjar/Crazy Egg:</strong> User behavior tracking</li>
        <li><strong>Google Tag Manager:</strong> Event tracking</li>
      </ul>
      
      <h3>Key Metrics untuk UMKM:</h3>
      
      <ul>
        <li>Conversion rate</li>
        <li>Bounce rate</li>
        <li>Average session duration</li>
        <li>Pages per session</li>
        <li>Traffic sources</li>
        <li>Goal completions</li>
      </ul>
      
      <h2>Budget-Friendly Solutions</h2>
      
      <h3>Platform Website untuk UMKM:</h3>
      
      <ul>
        <li><strong>WordPress:</strong> Fleksible, banyak themes/plugins</li>
        <li><strong>Shopify:</strong> Khusus e-commerce</li>
        <li><strong>Wix/Squarespace:</strong> User-friendly, no coding</li>
        <li><strong>Custom development:</strong> Maximum customization</li>
      </ul>
      
      <h3>Cost-Effective Features:</h3>
      
      <ul>
        <li>WhatsApp integration untuk customer service</li>
        <li>Social media feeds</li>
        <li>Email marketing integration</li>
        <li>Live chat (many free options)</li>
      </ul>
      
      <h2>Maintenance dan Updates</h2>
      
      <h3>Regular Tasks:</h3>
      
      <ul>
        <li>Content updates</li>
        <li>Security updates</li>
        <li>Performance monitoring</li>
        <li>Backup management</li>
        <li>SEO optimization</li>
      </ul>
      
      <h2>Kesimpulan</h2>
      <p>Website yang convert tinggi adalah kombinasi dari design yang user-friendly, content yang compelling, dan technical optimization yang solid. Untuk UMKM, fokus pada elements yang paling impact terhadap conversion dan build incrementally.</p>
    `,
    author: "Lisa Amelia",
    publishDate: "2024-01-08",
    readTime: "15 min",
    category: "website",
    tags: ["website", "conversion optimization", "umkm", "ux design"],
    featuredImage:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    isPopular: false,
    views: 1890,
  },

  {
    id: 5,
    slug: "digital-marketing-budget-umkm",
    title: "5 Tips Mengatur Budget Digital Marketing untuk UMKM",
    excerpt:
      "Panduan praktis mengalokasikan budget digital marketing yang terbatas untuk hasil maksimal. Termasuk template budget allocation.",
    content: `
      <p>Salah satu tantangan terbesar UMKM dalam digital marketing adalah keterbatasan budget. Artikel ini akan membantu Anda mengalokasikan budget dengan efektif.</p>
      
      <h2>Mengapa Budget Planning Penting?</h2>
      <ul>
        <li>Maximize ROI</li>
        <li>Prevent overspending</li>
        <li>Fokus pada channel yang efektif</li>
        <li>Measurable results</li>
      </ul>
      
      <h2>5 Tips Budget Allocation</h2>
      
      <h3>1. Tentukan Persentase dari Revenue</h3>
      <p>Rule of thumb: alokasikan 7-8% dari gross revenue untuk marketing.</p>
      
      <h3>2. Prioritaskan Channel dengan ROI Tinggi</h3>
      <p>Alokasi budget berdasarkan historical performance.</p>
      
      <h3>3. Reserve Budget untuk Testing</h3>
      <p>Sisihkan 20% budget untuk mencoba channel/strategi baru.</p>
      
      <h3>4. Seasonal Adjustment</h3>
      <p>Sesuaikan budget dengan peak season bisnis Anda.</p>
      
      <h3>5. Emergency Fund</h3>
      <p>Simpan 10% untuk opportunity atau crisis management.</p>
      
      <h2>Sample Budget Allocation</h2>
      
      <p>Untuk UMKM dengan budget Rp 5 juta/bulan:</p>
      <ul>
        <li>Google Ads: 40% (Rp 2 juta)</li>
        <li>Social Media Ads: 25% (Rp 1.25 juta)</li>
        <li>Content Creation: 20% (Rp 1 juta)</li>
        <li>Tools & Software: 10% (Rp 500 ribu)</li>
        <li>Testing/Misc: 5% (Rp 250 ribu)</li>
      </ul>
      
      <h2>Tools untuk Budget Management</h2>
      
      <ul>
        <li>Google Sheets untuk tracking</li>
        <li>Platform analytics untuk ROI calculation</li>
        <li>Monthly review dan adjustment</li>
      </ul>
      
      <h2>Kesimpulan</h2>
      <p>Budget planning yang baik adalah foundation untuk digital marketing yang sukses. Start small, measure everything, dan scale what works.</p>
    `,
    author: "Andi Wijaya",
    publishDate: "2024-01-05",
    readTime: "6 min",
    category: "tips-umkm",
    tags: ["budget planning", "umkm", "digital marketing", "roi"],
    featuredImage:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    isPopular: false,
    views: 1520,
  },

  {
    id: 6,
    slug: "content-marketing-strategi-umkm",
    title: "Content Marketing Strategy yang Efektif untuk UMKM",
    excerpt:
      "Strategi content marketing yang terjangkau dan efektif untuk UMKM. Termasuk content calendar template dan tips production.",
    content: `
      <p>Content marketing adalah strategi jangka panjang yang sangat efektif untuk UMKM karena cost-effective dan dapat membangun brand authority.</p>
      
      <h2>Mengapa Content Marketing Penting untuk UMKM?</h2>
      <ul>
        <li>Build brand awareness dengan biaya rendah</li>
        <li>Establish authority dan expertise</li>
        <li>Improve SEO ranking</li>
        <li>Generate leads organik</li>
        <li>Nurture existing customers</li>
      </ul>
      
      <h2>Jenis Content yang Efektif untuk UMKM</h2>
      
      <h3>1. Educational Content</h3>
      <p>Tips, tutorials, how-to guides yang relevan dengan industri Anda.</p>
      
      <h3>2. Behind-the-Scenes Content</h3>
      <p>Process pembuatan, daily operations, team introductions.</p>
      
      <h3>3. Customer Stories</h3>
      <p>Testimonials, case studies, user-generated content.</p>
      
      <h3>4. Industry News & Insights</h3>
      <p>Commentary tentang tren industry, news analysis.</p>
      
      <h2>Content Distribution Strategy</h2>
      
      <h3>Owned Media:</h3>
      <ul>
        <li>Website blog</li>
        <li>Email newsletter</li>
        <li>WhatsApp broadcast</li>
      </ul>
      
      <h3>Earned Media:</h3>
      <ul>
        <li>Social media shares</li>
        <li>Word-of-mouth</li>
        <li>PR mentions</li>
      </ul>
      
      <h3>Paid Media:</h3>
      <ul>
        <li>Social media ads</li>
        <li>Google Ads</li>
        <li>Influencer partnerships</li>
      </ul>
      
      <h2>Content Production Tips untuk UMKM</h2>
      
      <h3>1. Repurpose Content</h3>
      <p>Satu piece of content bisa di-repurpose menjadi multiple formats:</p>
      <ul>
        <li>Blog post → Social media posts</li>
        <li>Video → Blog post + Audio podcast</li>
        <li>Infographic → Carousel posts</li>
      </ul>
      
      <h3>2. User-Generated Content</h3>
      <p>Encourage customers untuk create content:</p>
      <ul>
        <li>Photo contest</li>
        <li>Review incentives</li>
        <li>Hashtag campaigns</li>
      </ul>
      
      <h3>3. Batch Production</h3>
      <p>Buat multiple content pieces dalam satu session untuk efisiensi.</p>
      
      <h2>Content Calendar Planning</h2>
      
      <h3>Monthly Themes:</h3>
      <ul>
        <li>Week 1: Educational content</li>
        <li>Week 2: Behind-the-scenes</li>
        <li>Week 3: Customer spotlight</li>
        <li>Week 4: Industry insights</li>
      </ul>
      
      <h3>Content Mix (80/20 Rule):</h3>
      <ul>
        <li>80%: Value-driven content</li>
        <li>20%: Promotional content</li>
      </ul>
      
      <h2>Measuring Content Performance</h2>
      
      <h3>Key Metrics:</h3>
      <ul>
        <li>Website traffic from content</li>
        <li>Social media engagement</li>
        <li>Lead generation</li>
        <li>Email list growth</li>
        <li>Brand mention increase</li>
      </ul>
      
      <h2>Budget-Friendly Content Tools</h2>
      
      <h3>Free Tools:</h3>
      <ul>
        <li>Canva untuk design</li>
        <li>Google Docs untuk writing</li>
        <li>Smartphone untuk photo/video</li>
        <li>Buffer/Hootsuite free plan</li>
      </ul>
      
      <h3>Affordable Paid Tools:</h3>
      <ul>
        <li>Canva Pro (Rp 150k/bulan)</li>
        <li>Grammarly (Rp 200k/bulan)</li>
        <li>Later Premium (Rp 300k/bulan)</li>
      </ul>
      
      <h2>Content Marketing Mistakes to Avoid</h2>
      
      <ul>
        <li>Too much promotional content</li>
        <li>Inconsistent posting schedule</li>
        <li>Not engaging with audience</li>
        <li>Ignoring analytics</li>
        <li>Not having clear goals</li>
      </ul>
      
      <h2>Kesimpulan</h2>
      <p>Content marketing adalah marathon, bukan sprint. Consistency dan value adalah kunci sukses. Mulai dengan resources yang ada dan build momentum secara bertahap.</p>
    `,
    author: "Maya Sari",
    publishDate: "2024-01-03",
    readTime: "9 min",
    category: "tips-umkm",
    tags: ["content marketing", "umkm", "brand building", "seo"],
    featuredImage:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    isPopular: true,
    views: 2200,
  },
];

// Popular articles for sidebar
export const popularArticles = blogArticles
  .filter((article) => article.isPopular)
  .sort((a, b) => b.views - a.views)
  .slice(0, 5);

// Recent articles
export const recentArticles = blogArticles
  .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate))
  .slice(0, 6);

// Get article by slug
export const getArticleBySlug = (slug) => {
  return blogArticles.find((article) => article.slug === slug);
};

// Get related articles
export const getRelatedArticles = (currentArticle, count = 3) => {
  return blogArticles
    .filter(
      (article) =>
        article.id !== currentArticle.id &&
        (article.category === currentArticle.category ||
          article.tags.some((tag) => currentArticle.tags.includes(tag)))
    )
    .slice(0, count);
};

// Get articles by category
export const getArticlesByCategory = (categoryId) => {
  if (categoryId === "all") {
    return blogArticles;
  }
  return blogArticles.filter((article) => article.category === categoryId);
};
